//import NotFoundData from "components/NotFoundData";
import styled from "@emotion/styled";
import { Row, Select, Image, Button, Space, message } from "antd";
import { useAppDispatch, useAppSelector } from "store";
import { setLoading } from "store/slices/loadingSlice";
import NotFoundData from "components/NotFoundData";
import { Dispatch, FC, SetStateAction, useEffect, useState, useRef, useCallback } from "react";
import { GetDataOrderListData, GetDataOrderListItems } from "services/interface";
import { useGetBankActiveList, useGetBankAllList } from "hooks/useFactory";
import OrderTableList, { OrderTableListRef } from "components/OrderManage/OrderPrepareShip/OrderTableList";
import SearchOrderForm from "../OrderTabsCard/SearchOrderForm";
import ExportToProduction from "./ExportToProduction";
import noImage from "assets/images/no-image.png";
import { checkSpeedMerchantStatus, checkThailandPostMerchantStatus, getDataNewOrder } from "services/ordersApi";
import CallShippingModal, { OrderShippingSummaryDetail } from "./CallShippingModal";
import {
  PREPARE_SHIP_SELECT_ALL_CAP,
  filterSelectableOrderIds,
  fetchShipItemsMap,
  fetchShippingQueueStatusMap,
  orderUsesPlatformShippingLabel,
} from "./prepareShipSelection";
import { ShipItemsSummary } from "./selfTracking";
const { Option } = Select;

interface OrderPrepareShipProps {
  data: GetDataOrderListData | undefined;
  isLoading: boolean;
  refetch: () => void;
  setSearchInput: Dispatch<SetStateAction<string>>;
  searchInput: string; // currentPage: number;
  refectShipped: () => void;
  refetchCancel?: () => void;
  IsHiddenPersonInfo?: boolean;
  setDateInput: Dispatch<SetStateAction<string>>;
  dateInput: string;
  refetchCredit?: () => void;
  setOpenForm?: Dispatch<SetStateAction<boolean>>;
}

const OrderPrepareShip: FC<OrderPrepareShipProps> = ({
  data,
  isLoading,
  refetch,
  setSearchInput,
  searchInput,
  refectShipped,
  refetchCancel,
  IsHiddenPersonInfo,
  setDateInput,
  dateInput,
  refetchCredit,
  setOpenForm
}) => {
  const dispatch = useAppDispatch();
  const factory_id = useAppSelector(
    (state) => state.auth.profile?.user?.role?.ref_id
  );

  const { data: dataBank } = useGetBankActiveList(factory_id || "");
  const { contact } = useAppSelector((state) => state.auth);
  const userContactData = useAppSelector((state) => state.auth.contact);

  const use_platform_transport = contact?.use_platform_transport;
  console.log("use_platform_transport", use_platform_transport);

  const childrenBank: React.ReactNode[] = [];
  dataBank?.data?.map((item) => {
    return childrenBank.push(
      <Option key={item.id} value={item.id}>
        <span style={{ fontSize: '12px' }}>
          <ImageWrapper>
            <Image src={item.image ?? noImage} alt={item.bank_name} preview={false} /> {item.bank_name} {item.account_no} {item.account_name}
          </ImageWrapper>
        </span>
      </Option>
    );
  });

  const [hasSpeedMerchant, setHasSpeedMerchant] = useState(false);
  const [hasThailandPostMerchant, setHasThailandPostMerchant] = useState(false);

  useEffect(() => {
    const fetchMerchantStatus = async () => {
      try {
        const [speedRes, tpRes] = await Promise.all([
          checkSpeedMerchantStatus(),
          checkThailandPostMerchantStatus(),
        ]);
        if (speedRes.status === 'success') setHasSpeedMerchant(speedRes.data.has_speed_merchant);
        if (tpRes.status === 'success') setHasThailandPostMerchant(tpRes.data.has_thailand_post_merchant);
      } catch (error) {
        console.error("Failed to check merchant status", error);
      }
    };
    fetchMerchantStatus();
  }, []);

  useEffect(() => {
    if (isLoading) {
      dispatch(setLoading(true));
    } else {
      dispatch(setLoading(false));
    }
  }, [dispatch, isLoading]);

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [selectedOrdersCache, setSelectedOrdersCache] = useState<
    Record<string, GetDataOrderListItems>
  >({});
  const [showCallShipping, setShowCallShipping] = useState(false);
  const [selectAllLoading, setSelectAllLoading] = useState(false);
  const orderTableRef = useRef<OrderTableListRef>(null);

  const totalRecord = parseInt(String(data?.total_record ?? "0"), 10) || 0;

  useEffect(() => {
    setSelectedRowKeys([]);
    setSelectedOrdersCache({});
  }, [searchInput, dateInput]);

  const tabSelected = useAppSelector((state) => state.order.tabSelected);
  useEffect(() => {
    if (tabSelected !== "1") {
      setSelectedRowKeys([]);
      setSelectedOrdersCache({});
    }
  }, [tabSelected]);

  const syncCacheFromPage = useCallback(
    (keys: React.Key[], pageRows: GetDataOrderListItems[] | undefined) => {
      if (!pageRows?.length) return;
      const keySet = new Set(keys.map(String));
      setSelectedOrdersCache((prev) => {
        const next = { ...prev };
        pageRows.forEach((row) => {
          if (keySet.has(row.order_id)) {
            next[row.order_id] = row;
          } else {
            delete next[row.order_id];
          }
        });
        return next;
      });
    },
    []
  );

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
    syncCacheFromPage(newSelectedRowKeys, data?.order_data);
  };

  const clearSelection = () => {
    setSelectedRowKeys([]);
    setSelectedOrdersCache({});
  };

  const getSelectedOrders = (): GetDataOrderListItems[] => {
    return selectedRowKeys.map((key) => {
      const id = String(key);
      if (selectedOrdersCache[id]) return selectedOrdersCache[id];
      const fromPage = data?.order_data?.find((o) => o.order_id === id);
      if (fromPage) return fromPage;
      return { order_id: id } as GetDataOrderListItems;
    });
  };

  const handleSelectAllAcrossPages = useCallback(async () => {
    const fid = userContactData?.id;
    if (!fid) {
      message.error("ไม่พบข้อมูลโรงงาน");
      return;
    }
    if (totalRecord === 0) {
      message.info("ไม่มีรายการให้เลือก");
      return;
    }
    setSelectAllLoading(true);
    try {
      const cap = Math.min(totalRecord, PREPARE_SHIP_SELECT_ALL_CAP);
      const res = await getDataNewOrder({
        status: "factory_approve",
        search: searchInput,
        order_date: dateInput,
        offset: 0,
        limit: cap,
        factory_id: fid,
      });
      const allRows = res.data?.order_data ?? [];
      const labelFlowRows = allRows.filter((row) =>
        orderUsesPlatformShippingLabel(row)
      );
      const labelFlowIds = labelFlowRows.map((r) => r.order_id);

      let queueMap: Record<string, string> = {};
      let shipItemsMap: Record<string, ShipItemsSummary> = {};
      if (labelFlowIds.length > 0) {
        [queueMap, shipItemsMap] = await Promise.all([
          fetchShippingQueueStatusMap(labelFlowIds),
          fetchShipItemsMap(labelFlowIds),
        ]);
      }

      const ids = filterSelectableOrderIds(labelFlowRows, queueMap, shipItemsMap);
      const cache: Record<string, GetDataOrderListItems> = {};
      labelFlowRows.forEach((row) => {
        if (ids.includes(row.order_id)) {
          cache[row.order_id] = row;
        }
      });

      setSelectedRowKeys(ids);
      setSelectedOrdersCache(cache);

      const skippedInQueue = labelFlowRows.length - ids.length;
      if (ids.length === 0) {
        message.info("ไม่มีรายการที่ออก Label ได้ในขณะนี้ (อาจเข้าคิวหรือออก Label แล้ว หรือไม่ใช่ app_agent / ecommerce_web)");
      } else if (cap < totalRecord) {
        message.warning(
          `เลือกได้สูงสุด ${cap} รายการต่อครั้ง (จากทั้งหมด ${totalRecord} ในแท็บ) — เลือก ${ids.length} รายการที่ออก Label ได้`
        );
      } else if (skippedInQueue > 0) {
        message.info(
          `เลือก ${ids.length} รายการที่ออก Label ได้`
        );
      }
    } catch (e) {
      console.error(e);
      message.error("โหลดรายการเพื่อเลือกทั้งหมดไม่สำเร็จ");
    } finally {
      setSelectAllLoading(false);
    }
  }, [userContactData?.id, totalRecord, searchInput, dateInput]);

  const refetchData = () => {
    refetch();
    refectShipped(); // ← refetch แถบ "กำลังจัดส่ง" พร้อมกัน เพื่อให้เห็น order ที่ย้ายสถานะแล้วทันที
  };

  useEffect(() => {
    const handleForceRefresh = () => refetchData();
    window.addEventListener('forceRefreshOrderTable', handleForceRefresh);
    return () => {
      window.removeEventListener('forceRefreshOrderTable', handleForceRefresh);
    };
  }, [refetch, refectShipped]);

  return (
    <>
      <WrapperAll>
        <HeadWrapper>
          <SearchOrderForm
            searchInput={searchInput}
            setSearchInput={setSearchInput}
            setDateInput={setDateInput}
            dateInput={dateInput}
          />
          <RightIconWrapper>
            {/* ถ้าส่งกับ platform ให้แสดงถ้าส่งแบบลุงอเนกไม่ต้องแสดง */}
            {(hasSpeedMerchant || hasThailandPostMerchant) && (
              <>
                {selectedRowKeys.length === 0 ? (
                  <Button
                    type="primary"
                    loading={selectAllLoading}
                    disabled={totalRecord === 0}
                    onClick={() => void handleSelectAllAcrossPages()}
                    style={{ marginRight: 10}}
                  >
                    เลือกทั้งหมดที่ออก Label ได้
                  </Button>
                ) : (
                  <Space size={8} style={{ marginRight: 10 }}>
                    <Button type="link" onClick={clearSelection}>
                      ล้างการเลือก
                    </Button>
                    <Button type="primary" onClick={() => setShowCallShipping(true)}>
                      ออกเลขพัสดุทั้งหมด {selectedRowKeys.length} รายการ
                    </Button>
                  </Space>
                )}
              </>
            )}
            <ExportToProduction />
            {setOpenForm && contact?.use_platform_transport === false && (
              <Button type="primary" onClick={() => {
                setOpenForm(true);
              }}>
                เพิ่มคำสั่งซื้อ
              </Button>
            )}
          </RightIconWrapper>
        </HeadWrapper>
        <CardWrapperTable>
          <OrderTableList
            ref={orderTableRef}
            data={data}
            childrenBank={childrenBank}
            refetchData={refetchData}
            refectShipped={refectShipped}
            refetchCancel={refetchCancel}
            IsHiddenPersonInfo={IsHiddenPersonInfo}
            hasSpeedMerchant={hasSpeedMerchant}
            hasThailandPostMerchant={hasThailandPostMerchant}
            selectedRowKeys={selectedRowKeys}
            onSelectChange={onSelectChange}
            factory_id={userContactData?.id || ''}
          />
        </CardWrapperTable>

        <CallShippingModal
          visible={showCallShipping}
          onClose={() => setShowCallShipping(false)}
          selectedOrders={getSelectedOrders()}
          factoryId=""
          onSuccess={(ids, details) => {
            setShowCallShipping(false);
            clearSelection();
            
            // Immediate UI update per order
            if (orderTableRef.current?.overrideQueueStatus && details && details.length > 0) {
              details.forEach((d: OrderShippingSummaryDetail) => {
                const forcedStatus = (d.y === 0 && d.z > 0) ? 'SUCCESS_WAITING_TRACKING' : 'PROCESSING';
                orderTableRef.current?.overrideQueueStatus([d.order_id], forcedStatus);
              });
            } else if (orderTableRef.current?.overrideQueueStatus) {
              orderTableRef.current.overrideQueueStatus(ids, 'PROCESSING');
            }
            orderTableRef.current?.refreshShippingState();

            refetchData();
            refectShipped();
          }}
        />
      </WrapperAll>
    </>
  );
};

export default OrderPrepareShip;

const WrapperAll = styled.div`
  padding: 10px 0px 10px 0px;
  background-color: #efefef;
`;

const HeadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-bottom: 10px;
`;
const CardWrapperTable = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  background-color: #ffffff;
  padding: 5px;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const OptionContent = styled.div`
  display: flex;
  align-items: center;
`;

const ImageWrapper = styled.div`
  margin-right: 8px;
  width: 20px;  
  height: 20px; 
  img {
    width: 100%;
    height: 100%;
  }
`;
